<template>
  <div
    id="v-stepper"
    class="steps-container"
    :class="{ toc: toc, 'vertical-style': vertical }"
  >
    <VStepperStep
      v-for="(step, index) in labels"
      :key="step"
      :step-number="index + 1"
      :step-title="step"
      @clicked="emitStepChanged"
      :vertical="vertical"
      :visited="checkIfVisited(index + 1)"
      :active="activeStep(index + 1)"
      :toc="toc"
      :hide-not-visited="hideNotVisited"
    />
  </div>
</template>

<script>
import VStepperStep from "./VStepperStep.vue";
import { usePersistedValues } from "../../composables/usePersistedValues";

// VStepper props info is available in the Storybook documentation - npm run storybook

export default {
  name: "VStepper",
  props: {
    labels: { type: Array, required: true },
    currentStep: { type: Number, required: true },
    uniqueId: { type: String, default: null },
    trackVisits: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    hideNotVisited: { type: Boolean, default: false },
    // Display as table of contents.
    toc: { type: Boolean, default: false },
  },
  data() {
    return {
      visitedSteps: {},
    };
  },
  components: {
    VStepperStep,
  },
  setup() {
    const { getPersistedValue, setPersistedValue, fetchForRoute } =
      usePersistedValues({
        module: "bio",
        route: "*",
      });

    return {
      getPersistedValue,
      setPersistedValue,
      fetchForRoute,
    };
  },
  async mounted() {
    if (this.trackVisits) {
      await this.fetchForRoute(["visitedSteps"]);
      if (this.trackVisits) {
        const visitedSteps = await this.getPersistedValue("visitedSteps");
        this.visitedSteps = visitedSteps.value || {};
      }
    }
    // Save first step
    this.saveCurrentStep();
  },
  computed: {
    currentIdStep() {
      if (this.uniqueId) {
        return this.uniqueId + "-" + this.currentStep;
      }
      return "";
    },
  },
  methods: {
    saveCurrentStep() {
      if (this.currentIdStep !== "" && this.currentIdStep) {
        if (this.visitedSteps[this.currentIdStep] === undefined) {
          this.visitedSteps[this.currentIdStep] = true;
        }
      }
    },
    emitStepChanged(event) {
      this.$emit("step-changed", event);
    },
    checkIfVisited(step) {
      const uniqueIdStep = this.uniqueId + "-" + step;
      return this.visitedSteps[uniqueIdStep] !== undefined
        ? this.visitedSteps[uniqueIdStep]
        : false;
    },
    activeStep(step) {
      return this.currentStep === step;
    },
  },
  updated() {
    this.saveCurrentStep();
    if (this.trackVisits) {
      this.setPersistedValue({
        key: "visitedSteps",
        newValue: this.visitedSteps,
      });
    }
  },
};
</script>

<style scoped>
.steps-container {
  display: flex;
  flex-direction: row;
  margin: 0.5rem 0;
}

/* For vertical styling, pass vertical prop from parent */
.steps-container.vertical-style {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
}
.steps-container.vertical-style.toc {
  gap: 0.75rem;
}
.steps-container.vertical-style > .steps {
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.steps-container.vertical-style.toc > .steps {
  flex-direction: row;
}
</style>
